<template>
  <div style="display: flex;align-items: center;padding: 10px;border: 1px solid #ccc;margin-top: 10px;">
    <dateTimePickerN :is-future="isFuture" v-model="date[0]"></dateTimePickerN>
    ——
    <dateTimePickerN :is-future="isFuture"  v-model="date[1]" :isDateCycle="true"></dateTimePickerN>
  </div>
</template>

<script>
import dateTimePickerN from "./dateTimePickerN";

export default {
  name: "timePickerGroup",
  props: {
    value: {},
    isFuture: {
      default: false,
    },
  },
  data() {
    return {
      valueAfter: this.value,
      date: [
        {
          yearSelect: '',
          monthSelect: '',
          daySelect: ''
        },
        {
          yearSelect: '',
          monthSelect: '',
          daySelect: ''
        }
      ]
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.valueAfter = val
      }
    },
    valueAfter: {
      handler(val) {
        if (val) {
          this.date = val
        }
      },
      deep: true,
      immediate: true
    },
    date(val) {
      console.log(val);

      if (val[0].yearSelect && val[0].monthSelect, val[0].daySelect && val[1].yearSelect && val[1].monthSelect, val[1].daySelect) {
        let dateA = new Date(this.getValueYear(val[0].yearSelect,0), this.getValueMonth(val[0].monthSelect,0), this.getValueDay(val[0].daySelect,0));
        let dateB = new Date(this.getValueYear(val[1].yearSelect,1), this.getValueMonth(val[1].monthSelect,1), this.getValueDay(val[1].daySelect,1));
        if(dateB < dateA) {
          val[1] = {
            yearSelect: "",
            monthSelect: "",
            daySelect: "",
          }
        }
      }
      this.$emit('input', val)
    },
  },
  methods: {
    getValueYear(text,type) {
      switch (text) {
        case '不清楚':
          return type == 0 ? 1 : new Date().getFullYear() + 3
          break
        default:
          return text
          break
      }
    },
    getValueMonth(text,type) {
      switch (text) {
        case '不清楚':
          return type == 0 ? 1 : 12
          break
        case '上半年':
          return 1
          break
        case '下半年':
          return 6
          break
        default:
          return text
          break
      }
    },
    getValueDay(text,type) {
      switch (text) {
        case '不清楚':
          return type == 0 ? 1 : 31
          break
        default:
          return text
          break
      }
    },
  },
  components: {
    dateTimePickerN
  }
}
</script>

<style scoped>

</style>